/**
 * PageTransition — subtle fade between routes (admin excluded).
 *
 * Editorial choice: ~280ms opacity-only crossfade, no translate. This avoids
 * fighting with the entrance animations of in-view sections on the next page.
 */
import { AnimatePresence, motion } from "framer-motion";
import usePreferStaticUI from "@/lib/usePreferStaticUI";
import { useLocation } from "react-router-dom";

export const PageTransition = ({ children }) => {
  const location = useLocation();
  const reduced = usePreferStaticUI();
  const isAdmin = location.pathname.startsWith("/admin");

  if (isAdmin || reduced) return children;

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: reduced ? 0 : 0.22, ease: [0.22, 0.61, 0.36, 1] }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default PageTransition;
